import { Component, Input, ElementRef, AfterViewInit, NgZone, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { S25Const } from "../util/s25-const";
import { TypeManagerDecorator } from "../main/type.map.service";
import { S25Util } from "../util/s25-util";

@TypeManagerDecorator("s25-ng-google-map")
@Component({
    selector: "s25-ng-google-map",
    template: `
        @if (placeUrl) {
            <div #mapContainer style="width:100%;height:400px"></div>
            <a [href]="placeUrl" target="_blank" rel="noopener" class="place-btn s25-btn"
                >Click to see on Google Maps</a
            >
        } @else {
            none
        }
    `,
    styles: `
        :host {
            display: block;
            padding: 1rem;

            .place-btn.s25-btn {
                display: block;
                width: 100%;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25GoogleMapComponent implements OnInit, AfterViewInit {
    @Input() latitude!: number | string;
    @Input() longitude!: number | string;
    @Input() zoom: number = 15;

    placeUrl: string;

    constructor(
        private el: ElementRef,
        private ngZone: NgZone,
    ) {}

    ngOnInit() {
        if (S25Util.isDefined(this.latitude) && S25Util.isDefined(this.longitude))
            this.placeUrl = this.composePlaceUrl();
    }

    ngAfterViewInit() {
        !!this.placeUrl &&
            this.loadGoogleMapsScript().then(() => {
                this.ngZone.runOutsideAngular(this.initMap.bind(this));
            });
    }

    private loadGoogleMapsScript(): Promise<void> {
        if ((window as any).google && (window as any).google.maps) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            const scriptId = "google-maps-script";
            if (document.getElementById(scriptId)) {
                (document.getElementById(scriptId) as HTMLScriptElement).addEventListener("load", () => resolve());
                return;
            }
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = S25Const.googleMaps.apiUrl;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    private initMap() {
        const lat = parseFloat(this.latitude as string);
        const lng = parseFloat(this.longitude as string);
        const map = new (window as any).google.maps.Map(this.el.nativeElement.querySelector("div"), {
            center: { lat, lng },
            zoom: this.zoom,
            mapTypeId: "hybrid",
            mapTypeControl: true, // Shows the map type control (where tilt is available)
            streetViewControl: true, // Optional: shows Street View control
            styles: [
                {
                    featureType: "all",
                    elementType: "labels",
                    stylers: [{ visibility: "on" }],
                },
            ],
        });
        new (window as any).google.maps.Marker({
            position: { lat, lng },
            map,
        });
    }

    composePlaceUrl() {
        // https://www.google.com/maps/place/21.263798,-157.804094/@21.263798,-157.804094,15z
        return (
            S25Const.googleMaps.placeBaseUrl +
            "/" +
            this.latitude +
            "," +
            this.longitude +
            "/@" +
            +this.latitude +
            "," +
            this.longitude +
            "," +
            this.zoom +
            "z" +
            S25Const.googleMaps.placeTypeToken.satellite
        );
    }
}
